import React, { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Container } from '@material-ui/core'
import { Link } from 'gatsby-plugin-intl'
import Slider from 'react-slick'
import uuid from 'react-uuid'

import Alerts from '~/assets/home-features/alert.svg'
import Appreciation from '~/assets/home-features/appreciation.svg'
import Assets from '~/assets/home-features/asset.svg'
import Events from '~/assets/home-features/event.svg'
import Infrastructure from '~/assets/home-features/infrastructure.svg'
import Inspections from '~/assets/home-features/inspection.svg'
import Playbooks from '~/assets/home-features/playbook.svg'
import Proposals from '~/assets/home-features/proposal.svg'
import Reports from '~/assets/home-features/report.svg'
import Requests from '~/assets/home-features/request.svg'
import Routes from '~/assets/home-features/route.svg'
import Suggestions from '~/assets/home-features/suggestion.svg'
import Tasks from '~/assets/home-features/task.svg'
import Trips from '~/assets/home-features/trip.svg'
import Vehicles from '~/assets/home-features/vehicle.svg'
import Worklogs from '~/assets/home-features/worklog.svg'
import '~/styles/custom/resiCarousel.scss'
import translate from '~/locale'

import SectionSubtitle from './SectionSubtitle'
import SectionTitle from './SectionTitle'

const icons = {
  Suggestions: <Suggestions width={72} height={72} />,
  Requests: <Requests width={72} height={72} />,
  Appreciation: <Appreciation width={72} height={72} />,
  Alerts: <Alerts width={72} height={72} />,
  Proposals: <Proposals width={72} height={72} />,
  Events: <Events width={72} height={72} />,
  Reports: <Reports width={72} height={72} />,
  Infrastructure: <Infrastructure width={72} height={72} />,
  Vehicles: <Vehicles width={72} height={72} />,
  Assets: <Assets width={72} height={72} />,
  Worklogs: <Worklogs width={72} height={72} />,
  Trips: <Trips width={72} height={72} />,
  Inspections: <Inspections width={72} height={72} />,
  Tasks: <Tasks width={72} height={72} />,
  Routes: <Routes width={72} height={72} />,
  Playbooks: <Playbooks width={72} height={72} />,
}

function SliderArrowNext(props) {
  const { className, onClick } = props

  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  )
}

function SliderArrowPrev(props) {
  const { className, onClick } = props

  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  )
}

const ResiCarousel: React.FC = (props) => {
  const [height, setHeight] = useState(0)

  const {
    current,
    data: { title, text, items },
    className,
  } = props

  const widgetsCarousels2A = {
    dots: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
    responsive: [
      {
        breakpoint: 1150,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 800,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  }

  const colors = {
    Suggestions: 'btn-link-success',
    Requests: 'btn-link-primary',
    Appreciation: 'btn-link-orange',
    Alerts: 'btn-link-danger',
    Proposals: 'btn-link-pink-light',
    Events: 'btn-link-primary-light',
    Reports: 'btn-link-primary',
    Infrastructure: 'btn-link-primary',
    Vehicles: 'btn-link-primary',
    Assets: 'btn-link-primary',
    Worklogs: 'btn-link-primary',
    Trips: 'btn-link-primary',
    Inspections: 'btn-link-primary',
    Tasks: 'btn-link-primary',
    Routes: 'btn-link-primary',
    Playbooks: 'btn-link-primary',
  }

  return (
    <div id={current}>
      <div className={`resi-carousel ${className}`}>
        <Container className="py-3 px-md-5">
          <SectionTitle>{translate(title)}</SectionTitle>
          <SectionSubtitle>{translate(text)}</SectionSubtitle>
          <Slider className="overflow-hidden" {...widgetsCarousels2A}>
            {items.map((item) => (
              <div className="resi-carousel-item" key={uuid()}>
                <div
                  style={{
                    height: height === 0 ? 'initial' : `${height}px`,
                  }}
                  className="mx-3 my-5 card card-box-hover-rise text-center p-3 p-xl-4 mb-5 d-block"
                >
                  <div className="d-50 btn-icon text-white mb-4 mx-auto">
                    {icons[item.icon]}
                  </div>
                  <h5 className="font-weight-bold font-size-lg text-second mb-0">
                    {translate(item.title)}
                  </h5>
                  <div className="text-second opacity-8 mt-3 mb-4 card-text">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: translate(item.text),
                      }}
                    />
                  </div>
                  {item.buttonText && (
                    <div className="text-center">
                      <Button
                        component={Link}
                        to={item.link}
                        className={`${
                          colors[item.icon]
                        } p-0 text-uppercase font-weight-bold font-size-sm btn-link`}
                        variant="text"
                      >
                        <span>{translate(item.buttonText).toUpperCase()}</span>
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </Slider>
        </Container>
      </div>
    </div>
  )
}

export default ResiCarousel
